var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 2,
    height: 12,
    rx: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "4;12;8;16;6;14;10",
    dur: "1.2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "10;6;8;4;9;5;7",
    dur: "1.2s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 2,
    height: 8,
    rx: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "8;16;4;12;10;6;14",
    dur: "1.4s",
    repeatCount: "indefinite",
    begin: "0.1s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "8;4;10;6;7;11;5",
    dur: "1.4s",
    repeatCount: "indefinite",
    begin: "0.1s"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 2,
    height: 16,
    rx: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "16;8;18;6;12;20;10",
    dur: "1.1s",
    repeatCount: "indefinite",
    begin: "0.2s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "4;8;3;9;6;2;7",
    dur: "1.1s",
    repeatCount: "indefinite",
    begin: "0.2s"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 7,
    width: 2,
    height: 10,
    rx: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "6;14;8;12;4;16;9",
    dur: "1.3s",
    repeatCount: "indefinite",
    begin: "0.3s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "9;5;8;6;10;4;7.5",
    dur: "1.3s",
    repeatCount: "indefinite",
    begin: "0.3s"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 9,
    width: 2,
    height: 6,
    rx: 1
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "height",
    values: "10;6;14;8;12;4;11",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.4s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "y",
    values: "7;9;5;8;6;10;6.5",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "0.4s"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayingIcon);
export default __webpack_public_path__ + "static/media/playingIcon.e52efbcd69c04923c0bda793c3a66187.svg";
export { ForwardRef as ReactComponent };